import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "n-avatar" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }

import { PropType, ref, watch, computed } from 'vue';
import NTooltip from '../../control/tooltip/tooltip.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-avatar',
},
  __name: 'avatar',
  props: {
  imageUrl: {
    type: String,
  },
  size: {
    type: String as PropType<'s' | 'm' | 'l'>,
    default: 'm',
  },
  name: {
    type: String,
    default: 'unknown',
  },
  enableTooltip: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const props = __props;

const imageLoaded = ref(false);
const imageLoadError = ref(false);

watch(
  () => props.imageUrl,
  () => {
    imageLoaded.value = false;
    imageLoadError.value = false;
  },
);

const initials = computed(() => {
  if (!props.name) {
    return 'U';
  }
  return props.name
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
});

function stringToHSLColour(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = Math.abs(hash % 360);
  return `hsl(${Math.abs(h)}, 40%, 80%)`;
}

function handleImageLoad() {
  imageLoaded.value = true;
}

function handleImageErr() {
  imageLoadError.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.enableTooltip)
      ? (_openBlock(), _createBlock(NTooltip, {
          key: 0,
          position: "top",
          text: __props.name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["n-avatar__circle", {
          'n-avatar__circle--small': __props.size === 's',
          'n-avatar__circle--large': __props.size === 'l',
        }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
              style: _normalizeStyle({
          'background-color': __props.imageUrl && !imageLoadError.value ? 'transparent' : stringToHSLColour(__props.name),
        })
            }, [
              (__props.imageUrl && !imageLoadError.value)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: __props.imageUrl,
                    alt: `Avatar image for ${__props.name}`,
                    onLoad: handleImageLoad,
                    onError: handleImageErr
                  }, null, 40, _hoisted_2)), [
                    [_vShow, imageLoaded.value]
                  ])
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(initials.value), 1))
            ], 6)
          ]),
          _: 1
        }, 8, ["text"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["n-avatar__circle", {
          'n-avatar__circle--small': __props.size === 's',
          'n-avatar__circle--large': __props.size === 'l',
        }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click'))),
            style: _normalizeStyle({
          'background-color': __props.imageUrl && !imageLoadError.value ? 'transparent' : stringToHSLColour(__props.name),
        })
          }, [
            (__props.imageUrl && !imageLoadError.value)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.imageUrl,
                  alt: `Avatar image for ${__props.name}`,
                  onLoad: handleImageLoad,
                  onError: handleImageErr
                }, null, 40, _hoisted_5)), [
                  [_vShow, imageLoaded.value]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(initials.value), 1))
          ], 6)
        ]))
  ]))
}
}

})